<div class="header row">
	<div class="col offset-1">
		<h1 class="d-none d-lg-block">
			<img src="../assets/angola/f2flogo_angola.png">
			{{ 'SELF_ENROLLMENT_PORTAL' | translate}}
		</h1>
		<h2 class="d-none d-md-block d-lg-none">
			<img src="../assets/angola/f2flogo_angola.png">
			{{ 'SELF_ENROLLMENT_PORTAL' | translate}}
		</h2>
		<h5 class="d-block d-md-none">
			<img src="../assets/angola/f2flogo_angola.png">
			{{ 'SELF_ENROLLMENT_PORTAL' | translate}}
		</h5>
	</div>
	<div class="col-2">
		{{ 'LANGUAGE' | translate}}
		<button type="button" class="btn" (click)="changeLanguage('en')"><img src="../assets/i18n/english.png"></button>
		<button type="button" class="btn" (click)="changeLanguage('pt')"><img src="../assets/i18n/portuguese.png"></button>
	</div>
</div>
<main class="container">
	<app-toasts></app-toasts>
	<router-outlet (activate)="onActivate($event)"></router-outlet>
</main>
<footer class="footer">
	<div class="row">
		<div class="col-4 text-center">
			{{ 'TERMS_CONDITIONS' | translate}}
		</div>
		<div class="col-4 text-center">
			{{ 'PRIVACY_POLICY' | translate}}
		</div>
		<div class="col-4 text-center">
			&copy; Axon Wireless Technologies
		</div>
	</div>
</footer>
